import { Space } from "antd";
import CommonButton from "./CommonButton";
import LinkButton from "./LinkButton";
import "./PromptModal.scss";

const PromptModal = ({
  title,
  content,
  subContent,
  subContent3,
  // loading,
  acptBtnLbl,
  rejtBtnLbl,
  onAccept,
  onReject,
  contentClsName,
  subcontentClsName,
  subcontent3ClsName,
  acptBtnClsName,
  rejtBtnClsName,
  acptBtnType,
  rejtBtnType,
  direction,
  img
}) => {
  return (
    <div>
      <div className="modal-header-sec">
        {title}
      </div>
      {img && img}
      <div className="modal-body-section">
        <div className="content-container">
          <div className={!subContent ? subcontentClsName : contentClsName}>{content}</div>
          {subContent && <div className={subcontentClsName}>{subContent}</div>}
          {subContent3 && <div className={subcontent3ClsName}>{subContent3}</div>}
        </div>
        <div className="modal-btn-container">
          <Space direction={direction} align="center">
            {acptBtnType === "primary" ? <CommonButton
              className={acptBtnClsName}
              onClick={onAccept}
              label={acptBtnLbl}
            // loading={loading}
            /> : <LinkButton label={acptBtnLbl} className={rejtBtnClsName} />}

            {rejtBtnLbl && (rejtBtnType === "primary" ? <CommonButton
              className={rejtBtnClsName}
              onClick={onReject}
              label={rejtBtnLbl}
            /> : <LinkButton label={rejtBtnLbl} onClick={onReject} className={rejtBtnClsName} />)}
          </Space>
        </div>
      </div>
    </div>
  );
};

PromptModal.defaultProps = {
  title: "Confirmation",
  content: "",
  subContent: "",
  acptBtnLbl: "Yes",
  rejtBtnLbl: "No",
  // loading: false,
  contentClsName: "content-txt",
  subcontentClsName: "sub-content-txt",
  subcontent3ClsName: "",
  acptBtnType: "primary",
  rejtBtnType: "primary",
  acptBtnClsName: "common-button-green",
  rejtBtnClsName: "common-button-white",
  direction: "horizontal"
};

export default PromptModal;
